import { Container, Row, Col, Button } from 'react-bootstrap';
import '../App.css';
import Speed from './speed';

function Nav({ numberQuestion, setnumberQuestion }) {
    return (
        <div className="Nav">
            <Container className='test_nav'>
                <Row>
                    <Col sm={1}></Col>
                    <Col sm={5}>
                        <Row>
                            <Col xs={4}>
                                <Button className='button_nav' onClick={() => numberQuestion >= 1 ? setnumberQuestion(numberQuestion - 1) : setnumberQuestion(numberQuestion)}>השאלה הקודמת</Button>
                            </Col>
                            <Col xs={4}>
                                <Speed numberQuestion={numberQuestion} />
                            </Col>
                            <Col xs={4}>
                                <Button className='button_nav' onClick={() => numberQuestion < 29 ? setnumberQuestion(numberQuestion + 1) : setnumberQuestion(numberQuestion)}>השאלה הבאה</Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col sm={1}></Col>
                </Row>
            </Container>
        </div>
    );
}

export default Nav;